import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Button, DatePicker, Select, Checkbox } from '../../components';
import './ReportingEntitlementsConsumption.scss';
import { useLazyGetOrganizationQuery } from '../../api';
import { getOnlyOrganizations, getOnlyProjects, getSessionVar } from '../../lib/helpers';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

export const ActionBar = React.memo((props) => {
    const { isSupportOrSysAdmin, buttonText = 'Create Report', userOrganizations = [], userRole = '' } = props;
    const today = useMemo(() => dayjs(), []);
    const startOfMonth = useMemo(() => today.startOf('month'), [today]);
    const [getUserOrganization] = useLazyGetOrganizationQuery();

    const [selectedOrg, setSelectedOrg] = useState();
    const [selectedProject, setSelectedProject] = useState();
    const [organizations, setOrganizations] = useState([]);
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        window.reportingDateRange = {
            from: startOfMonth.format('YYYY-MM-DD'),
            to: today.format('YYYY-MM-DD'),
        };
    }, [startOfMonth, today]);

    const handleDateChange = useCallback((dates) => {
        if (dates?.[0] && dates?.[1]) {
            window.reportingDateRange = {
                from: dates[0].format('YYYY-MM-DD'),
                to: dates[1].format('YYYY-MM-DD'),
            };
        }
    }, []);

    const handleProjectChange = useCallback(
        (id = '') => {
            const currentProject = projects?.find((project) => project.id === id);
            setSelectedProject(currentProject);
            window?.handleProjectChange && window.handleProjectChange(currentProject);
        },
        [projects],
    );

    const handleOrgChange = useCallback(
        (orgId) => {
            handleProjectChange(null);
            setProjects([]);
            const currentOrg = organizations.find((org) => org?.id === orgId);
            setSelectedOrg(currentOrg);
            window?.handleOrgChange && window.handleOrgChange(currentOrg);
            if (orgId) {
                (async () => {
                    const result = await getUserOrganization({ orgId });
                    setProjects(result?.data?.projects);
                })();
            }
        },
        [handleProjectChange, organizations],
    );

    useEffect(() => {
        if (userOrganizations?.length) {
            const currentOrganization = getSessionVar('currentOrg');
            setOrganizations(getOnlyOrganizations(userOrganizations));
            setProjects(getOnlyProjects(userOrganizations));
            if (!isSupportOrSysAdmin) {
                handleOrgChange(currentOrganization.parent_organization);
                setSelectedProject(currentOrganization);
                window?.handleProjectChange && window.handleProjectChange(currentOrganization);
            }
        }
    }, [userOrganizations, isSupportOrSysAdmin, isSupportOrSysAdmin]);

    const organizationOptions = useMemo(
        () =>
            organizations.map((org) => ({
                label: org.name,
                value: org.id,
            })),
        [organizations],
    );

    const projectOptions = useMemo(() => {
        return projects?.map((prj) => ({
            label: prj.name,
            value: prj.id,
            selected: selectedProject?.id,
        }));
    }, [projects, selectedProject]);

    return (
        <div className="report-date-range-picker">
            <RangePicker defaultValue={[startOfMonth, today]} onChange={handleDateChange} format="MM-DD-YYYY" />
            {isSupportOrSysAdmin && (
                <Select
                    className="organization-select"
                    allowClear={true}
                    placeholder="Select Organization"
                    options={organizationOptions}
                    value={selectedOrg?.id}
                    onChange={handleOrgChange}
                    showSearch
                    optionFilterProp="label"
                />
            )}
            <Select
                className="organization-select"
                placeholder="Select Project"
                allowClear={true}
                options={projectOptions}
                value={selectedProject?.id}
                onChange={handleProjectChange}
                showSearch
                optionFilterProp="label"
            />
            <Button type="primary" onClick={() => window.buildReport()}>
                {buttonText}
            </Button>
            <Button type="primary" onClick={() => window.handleReportGeneration()} className="button button--primary">
                Download Report CSV
            </Button>
        </div>
    );
});
